import FieldsCollection from "../../fields3/collection/base/fields-collection"
import {EntityType} from "../../gd/const/item"
import {FieldType} from "../../fields3/field-type"
import FieldString from "../../fields3/generic/string/string";
import FieldDropdown from "../../fields3/generic/dropdown/dropdown";
import {SupportTicketPlatformOptions, SupportTicketTypeOptions} from "./constants";

const baseConfig = [
    {
        fieldId : 'subject',
        type    : FieldType.STRING,
        label   : 'Subject'
    },
    {
        fieldId : 'url',
        type    : FieldType.STRING,
        label   : 'Page URL'
    },
    {
        fieldId : 'description',
        type    : FieldType.TEXT,
        label   : 'Description'
    },
    {
        fieldId         : 'ticketTypeId',
        type            : FieldType.DROPDOWN,
        label           : 'Ticket Type',
        options         : SupportTicketTypeOptions,
        noValueOption   : false,
        showMenuMore    : false
    },
    {
        fieldId : 'platform',
        type    : FieldType.DROPDOWN,
        label   : 'Platform',
        options : SupportTicketPlatformOptions,
        noValueOption   : false,
        showMenuMore    : false
    }
]

export default class SupportTicketFields extends FieldsCollection {



    get subject()                       { return this.get('subject') as FieldString }
    get url()                           { return this.get('url') as FieldString }
    get description()                   { return this.get('description') as FieldString }
    get ticketTypeId()                  { return this.get('ticketTypeId') as FieldDropdown }
    get platform()                      { return this.get('platform') as FieldDropdown }

    constructor() {

        const fieldsConfig = baseConfig;
        // we can modify base config with params in constructor if needed
        super(fieldsConfig, EntityType.OFFICE);
    }
}
